import './StartGameScreen.css';

interface StartGameScreenProps {
  gameName: string;
  teamName: string;
  teamColor: string;
  numberOfSprints: number;
  onStartGame: () => void;
}

export default function StartGameScreen({ gameName, teamName, teamColor, numberOfSprints, onStartGame }: StartGameScreenProps) {
  return (
    <div className="start-game-screen">
      <div className="start-game-content">
        <h1 className="start-game-title">🏃‍♂️📊 Idle Sprint Planning Simulator</h1>
        
        <div className="game-info">
          <h2 style={{ color: teamColor }}>{teamName}</h2>
          <h3>{gameName}</h3>
          <p className="sprint-info">This game will last for {numberOfSprints} sprints</p>
        </div>
        
        <div className="start-game-description">
          <h3>Ready to Begin?</h3>
          <p>
            You are about to start the Sprint Planning Simulator as team <strong style={{ color: teamColor }}>{teamName}</strong>.
            Your goal is to manage your development team effectively over {numberOfSprints} sprints,
            delivering value to customers while maintaining a healthy team and positive cash flow.
          </p>
        </div>
        
        <button className="start-simulation-button" onClick={onStartGame}>
          🎮 Start Simulation
        </button>
      </div>
    </div>
  );
}
